import { render, staticRenderFns } from "./IndicationOfCareSituation.vue?vue&type=template&id=2e967b24&"
import script from "./IndicationOfCareSituation.vue?vue&type=script&lang=js&"
export * from "./IndicationOfCareSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports